import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { BoardService } from '../shared/services/board/board.service';
import { DashboardsSubMenuUrl } from '../shared/enums/dashboards-submenu.enum';
import { AppsettingsService } from '../shared/services/appsettings/appsettings.service';
import { AppSettings } from '../interfaces/app-settings.interface';

export const boardExistsGuard = (route: ActivatedRouteSnapshot) => {
	const boardService = inject(BoardService);
	const router = inject(Router);
	const appSettingsService = inject(AppsettingsService);
	const boardId = route.paramMap.get('id');

	return appSettingsService.getUserAppSettings().pipe(
		filter((settings): settings is AppSettings => !!settings),
		take(1),
		map(() => {
			const board = boardService.getBoard(boardId);

			if (!board) {
				return router.createUrlTree([DashboardsSubMenuUrl.createboard]);
			}

			return true;
		})
	);
};
